import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { selectors } from '../../../../modules/customer/profile/hardwareProducts'
import HardwareList from '../hardwareProducts/addHardwareForm/components/HardwareList';

const SummaryStep = ({ hardwareProducts }) => {
    const productsToCancel = hardwareProducts.productsList.filter(p => p.isToCancel === true);
    return (
        <div className="col-xs-12 col-md-6">
            <div>
                <br />
                <span className="info-text" >Hardware listed below will be cancelled. <br />Please verify and hit OK to send request.</span>
                <br />
                <br />
            </div>
            <div>
                <HardwareList hardwareList={productsToCancel} className="compact-list" />
            </div>
        </div>
    );
}


const mapStateToProps = createStructuredSelector({
    hardwareProducts: selectors.getHardwareProducts
});

export default connect(mapStateToProps)(SummaryStep);